<template>
  <div>
    <b-container style="margin-top: 4rem">
      <div
        style="
          border: #00a4ff solid 2px;
          padding: 16px;
          border-radius: 4px;
          margin-top: 16px;
        "
      >
        <h6><b>深圳农商行</b></h6>
        <hr />
        <b-form-group
          id="input-group-1"
          label="银行唯一序列号:"
          label-for="input-1"
        >
          <b-form-input
            id="input-1"
            v-model="bankSerialNumber"
            required
            placeholder="银行唯一序列号"
          ></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-2" label="银行编号:" label-for="input-2">
          <b-form-input
            id="input-2"
            v-model="bankCode"
            required
            placeholder="银行编号"
          ></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-2" label="定制类型:" label-for="input-2">
          <b-form-select
            v-model="customModel"
            :options="customModels"
          ></b-form-select>
        </b-form-group>

        <b-form-group
          id="input-group-2"
          label="卡种类型编码:"
          label-for="input-2"
        >
          <b-form-input
            id="input-2"
            v-model="cardTypeCode"
            required
            placeholder="卡种类型编码"
          ></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-2" label="姓氏编码:" label-for="input-2">
          <b-form-input
            id="input-2"
            v-model="nameCode"
            required
            placeholder="姓氏编码"
          ></b-form-input>
        </b-form-group>

        <div class="box">
          <b-button variant="outline-primary" @click="testSubmitCardBase64()"
            >提交订单测试</b-button
          >
          <b-button variant="outline-primary" @click="testEditCardBase64()"
            >修改订单测试</b-button
          >
        </div>
      </div>
    </b-container>
  </div>
</template>
<script>
export default {
  name: "Home_shzhnsh",
  data() {
    return {
      bankSerialNumber: "",
      bankCode: "0038",
      customModel: "1",
      cardTypeCode: "",
      nameCode: "",
      customModels: [
        {
          value: "1",
          text: "半定制",
        },
        {
          value: "2",
          text: "全定制",
        },
      ],
    };
  },
  mounted: function () {},
  methods: {
    testSubmitCardBase64: function () {
      this.$router.push({
        name: "BaseApplyAction",
        query: {
          bankSerialNumber: this.bankSerialNumber,
          bankCode: this.bankCode,
          customModel: this.customModel,
          cardTypeCode: this.cardTypeCode,
          nameCode: this.nameCode,
        },
      });
    },
    testEditCardBase64: function () {
      this.$router.push({
        name: "BaseQueryAction",
        query: {
          bankSerialNumber: this.bankSerialNumber,
          bankCode: this.bankCode,
        },
      });
    },
  },
};
</script>

<style scoped>
.box {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
</style>



// WEBPACK FOOTER //
// src/components/shenzhennshbank/Home_shzhnsh.vue